<!-- Native-Angular port of v2 audiences/{upcomingContestsList,pastContestsList}.html.
     Single template, *ngIf-branches on select (upcoming vs past). Upcoming
     has no background image / no stats; past has both. Empty list shows a
     translated placeholder. -->
<ft-initialized-content [isInitialized]="isInitialized">
  <ng-container *ngIf="select === 'upcoming'">
    <div class="placeholder-panel" [hidden]="filteredItems.length">
      {{'flipto.account.platform.NoUpcomingContests' | translate}}
    </div>

    <div class="ft-panel contest-panel upcoming"
         *ngFor="let contest of filteredItems"
         (click)="showContest(contest, 'details')">
      <div class="panel-image">
        <div class="panel-matte"></div>
      </div>
      <div class="contest-display">
        <div class="contest-display-content">
          <div class="contest-title">{{contest.name}}</div>
          <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="select === 'past'">
    <div class="placeholder-panel" [hidden]="filteredItems.length">
      {{'flipto.account.platform.ThereAreNoPastContests' | translate}}
    </div>

    <div class="ft-panel contest-panel past contest-active"
         *ngFor="let contest of filteredItems"
         (click)="showContest(contest, 'winners')">
      <div class="panel-image" [style.background-image]="'url(' + getContestBackgroundImage(contest) + ')'">
        <div class="panel-matte"></div>
      </div>
      <div class="contest-display">
        <div class="contest-display-content">
          <div class="contest-theme-label" *ngIf="contest.theme != 0">{{'flipto.account.platform.photoAdvocacy.ThemedContest' | translate}}</div>
          <div class="contest-title">{{contest.name}}</div>
          <div class="contest-date-range">{{contest.startDate | dateRange:contest.endDate}}</div>
        </div>
      </div>
      <div class="contest-stats ft-v-align-container">
        <div class="contest-stats-content ft-v-align-content">
          <p><ft-stat [value]="(contest.totalFinalists || 0) | number" [label]="'flipto.account.Storytellers' | translate | lowercase" /></p>
          <p><ft-stat [value]="(contest.totalShares || 0) | number" [label]="'flipto.account.TotalShares' | translate | lowercase" /></p>
          <p><ft-stat [value]="(contest.totalFollowers || 0) | number" [label]="'flipto.account.FriendsReached' | translate | lowercase" /></p>
          <p><ft-stat [value]="(contest.totalSignups || 0) | number" [label]="'flipto.account.WarmLeads' | translate | lowercase" /></p>
        </div>
      </div>
    </div>
  </ng-container>
</ft-initialized-content>
